import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Matrícula',
    path: '/academico/matricula',
    name: 'matricula',
    component: () => import('@/views/academico/matricula/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.MATRICULA_MENU_300200201 ,
],
    },
    goesToMenu: true,
  },
]
